<template>
  <div class="article-header">
    <h3 class="tit">{{ article.title }}</h3>
    <p class="num">
      <span>{{ article.pubdate | fmTime }}</span>
      <span>{{ article.read_count || 0 }} 阅读</span>
      <span>{{ article.comm_count || 0 }} 评论</span>
    </p>
    <div class="author">
      <van-image
        round
        width="0.9rem"
        height="0.9rem"
        fit="cover"
        :src="article.aut_photo"
      />
      <p class="name">{{ article.aut_name }}</p>
      <van-button
        :loading="followLoading"
        round
        size="mini"
        :type="article.is_followed ? 'default' : 'danger'"
        @click="handlerFollow(article)"
      >
        {{ article.is_followed ? "已关注" : "+ 关注" }}
      </van-button>
    </div>
  </div>
</template>
<script>
import { followMixin } from './mixins'
export default {
  name: 'ArtilceHeader',
  mixins: [followMixin],
  props: {
    article: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
<style scoped lang="less">
.article-header {
  padding: 18px 16px 0;
  .tit {
    font-size: 22px;
    line-height: 30px;
    font-weight: normal;
    word-break: break-all;
  }
  .num {
    padding-top: 12px;
    color: #a5a6ab;
    display: flex;
    font-size: 10px;
    span {
      height: 10px;
      line-height: 10px;
      ~ span {
        border-left: 1px solid #bfc2cb;
        margin-left: 5px;
        padding-left: 5px;
      }
    }
  }
  .author {
    display: flex;
    align-items: center;
    padding-top: 24px;
    .name {
      flex: 1;
      padding: 0 10px;
      font-size: 16px;
    }
    .van-button {
      width: 64px;
      height: 30px;
    }
  }
}
</style>
